import View from './View';
import { URL } from '../config.js';

class NologinView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Nologin Error Message';
  _message = 'Nologin Success Message';

  addHandlerSignup(handler) {
    this._parentElement.addEventListener('click', e => {
      this._signUp(e, handler);
    });
  }

  addHandlerSignupPopup(handler) {
    this._popupElement.addEventListener('click', e => {
      this._signUp(e, handler);
    });
  }

  addHandlerLogin(handler) {
    this._parentElement.addEventListener('click', e => {
      this._login(e, handler);
    });
  }

  addHandlerLoginPopup(handler) {
    this._popupElement.addEventListener('click', e => {
      this._login(e, handler);
    });
  }

  _signUp(e, handler) {
    const signup = e.target.closest('.nologin__btn--signup');
    if (!signup) return;
    handler('signup');
  }

  _login(e, handler) {
    const login = e.target.closest('.nologin__btn--login');
    if (!login) return;
    handler('login');
  }

  _generateMarkup() {
    return `
      <div class="row nologin__container">
        <p class="paragraph nologin__message">
          ${this._data}
        </p>
        <div class="nologin__btn--container">
          <button class="btn btn--signup nologin__btn--signup">Sign Up</button>
          <button class="btn btn--login nologin__btn--login">Login</button>
        </div>
        <p class="paragraph">
          <a href="${URL}forgotPassword" class="link nologin__link">Forgot password?</a>
        </p>
      </div>
    `;
  }
}

export default new NologinView();
